__turbopack_context__.v({
  "container": "PostedIn-module-scss-module__uBGNPq__container",
  "containerDefault": "PostedIn-module-scss-module__uBGNPq__containerDefault",
  "containerSecondary": "PostedIn-module-scss-module__uBGNPq__containerSecondary",
  "link": "PostedIn-module-scss-module__uBGNPq__link",
  "linkDefault": "PostedIn-module-scss-module__uBGNPq__linkDefault",
  "linkSecondary": "PostedIn-module-scss-module__uBGNPq__linkSecondary",
});
